/* FR: prev / next arrows laid over the active product image (desktop). Measured against the
   media box so they stay on the photo whatever the aspect ratio; switch via media-gallery. */
(() => {
  const desktop = () => window.matchMedia('(min-width: 750px)').matches;
  const init = (nav) => {
    if (nav.dataset.frReady) return; nav.dataset.frReady = '1';
    const gallery = nav.closest('media-gallery'); const viewer = nav.closest('slider-component');
    const list = viewer && viewer.querySelector('.product__media-list'); if (!gallery || !list) return;
    const items = () => [...list.querySelectorAll('.product__media-item[data-media-id]')];
    const current = () => { const i = items().findIndex((li) => li.classList.contains('is-active')); return i >= 0 ? i : 0; };
    const place = () => {
      const li = items()[current()]; if (!li) return;
      const box = li.querySelector('.product-media-container') || li;
      const b = box.getBoundingClientRect(); const v = viewer.getBoundingClientRect();
      if (b.width > 0) { nav.style.left = (b.left - v.left) + 'px'; nav.style.top = (b.top - v.top) + 'px'; nav.style.width = b.width + 'px'; nav.style.height = b.height + 'px'; }
    };
    place();
    if (window.ResizeObserver) new ResizeObserver(place).observe(list);
    window.addEventListener('resize', place); window.addEventListener('load', place);
    new MutationObserver(place).observe(list, { attributes: true, subtree: true, attributeFilter: ['class'] });
    nav.querySelectorAll('[data-dir]').forEach((btn) => btn.addEventListener('click', () => {
      const all = items(); if (all.length < 2) return;
      const next = (current() + Number(btn.dataset.dir) + all.length) % all.length;
      gallery.setActiveMedia(all[next].dataset.mediaId, false);
      setTimeout(place, 50);
    }));
  };
  const boot = () => document.querySelectorAll('[data-fr-gal-nav]').forEach(init);
  boot(); document.addEventListener('shopify:section:load', boot);
  new MutationObserver(boot).observe(document.body, { childList: true, subtree: true });
})();
